import { isObject } from "./type-witchcraft.js";
import { millisecondsToDays } from "./date.js";
export function isCardV1(card) {
    if (!isObject(card)) {
        return false;
    }
    else if (!("version" in card) ||
        card.version === 1 ||
        card.version === undefined) {
        return true;
    }
    else {
        return false;
    }
}
export function isCardV2(card) {
    if (!isObject(card)) {
        return false;
    }
    else {
        return card.version === 2;
    }
}
export function isCardArchived(card, compilations) {
    if (!card) {
        return false;
    }
    // all v1 cards are considered archived
    if (isCardV1(card)) {
        return true;
    }
    const daysInactive = daysSinceLastCardActivity(card, compilations);
    return daysInactive >= 180; // the card is considered archived after 6 months of inactivity
}
export function daysSinceLastCardActivity(card, compilations) {
    if (!card) {
        return 0;
    }
    const today = Date.now();
    const compilationList = card.compilations ?? compilations;
    const compilation = compilationList && compilationList.length > 0
        ? // copy compilations because sort is done in place
            [...compilationList].sort(function (a, b) {
                return b.createdAt - a.createdAt;
            })[0]
        : null;
    const dueDate = card.dueDate;
    const createdAt = card.createdAt;
    const lastActiveTime = compilation
        ? dueDate > createdAt
            ? dueDate
            : createdAt
        : dueDate;
    const daysInactive = Math.floor(millisecondsToDays(today - lastActiveTime));
    return daysInactive;
}
export function isCardLegacyUnlocked(card) {
    return card && card.payment;
}
export function getDefaultInviteEmailSubject({ title }) {
    return `Help contribute to a group video${title ? ` for ${title}` : "!"}`;
}
export function getCardInviteEmailSubject({ card, isAllowedToEditSubject, overrideSubject, }) {
    if (isAllowedToEditSubject) {
        return (overrideSubject ||
            card.inviteEmailSubject ||
            getDefaultInviteEmailSubject(card));
    }
    else {
        return getDefaultInviteEmailSubject(card);
    }
}
